<template>
    <h3 class="mb-6">Include a Peel & Stick End</h3>
    <div class="rounded-xl p-4 shadow-card lg:p-8">
        <div class="flex items-center gap-x-6">
            <CheckboxInput
                v-model="selectCrossSell"
                name="cross-sell-checkbox"
                class="large-checkbox"
                container-class="items-center"
                label-class="text-sm"
                @change="selectCrossSellChange($event)"
            />
            <div
                class="mb-4 aspect-[1/1] w-2/5 rounded-lg shadow-card sm:w-28 md:w-24 lg:mb-0 lg:w-32"
            >
                <img
                    :src="product.image?.src"
                    :alt="product.image?.alt"
                    class="h-full w-full object-contain p-2"
                />
            </div>
            <ConfiguratorQuantityInput
                v-model="quantity"
                class="ml-auto"
                :min="0"
                help-text="*Sold in quantities of 100"
                help-text-class="text-sm"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import CheckboxInput from '~/components/forms/CheckboxInput.vue';
import { CrossSellProduct } from '~/types/product';

defineProps<{
    product: CrossSellProduct;
}>();

const emit = defineEmits(['update:quantity']);

const selectCrossSell = ref(false);
const quantity = ref(0);

const selectCrossSellChange = (event) => {
    if (event.target.checked && quantity.value === 0) {
        quantity.value = 1;
    } else {
        quantity.value = 0;
    }
};

watchEffect(() => {
    if (quantity.value === 0) {
        selectCrossSell.value = false;
    }

    if (quantity.value > 0 && !selectCrossSell.value) {
        selectCrossSell.value = true;
    }

    emit('update:quantity', quantity.value);
});
</script>

<style lang="postcss" scoped>
:deep(input[type='checkbox'].large-checkbox) {
    @apply h-6 w-6 !important;
}
</style>
